import React, { useEffect } from 'react';

// Importing TagCloud for  3D Rotating Text Sphere
import TagCloud from 'TagCloud';

import '../../styles/Skill/Skill.scss';

const Skill = () => {
  // Animation settings for Text Cloud
  useEffect(() => {
    const container = '.tagcloud';
    let radii;

    // If 3D Text Sphere is not showing up after deployment remove the return (i.e, return() =>{}) function from below code
    return () => {
      const texts = [

       
    
      ];


      // Decrasing 'radius' value for small screen devices  
      function radiusValue() {
        if (window.screen.width <= 778) {
          radii = 150;
        } else {
          radii = 290;
        }
        return radii;
      }

      const options = {
        radius: radiusValue(),
        maxSpeed: 'normal',
        initSpeed: 'normal',
        keep: true,
      };

      TagCloud(container, texts, options);
    }
  }, []);
  return (
    <>
      <div className="skill">
        <div className="skill__main-container">
          <div className="skill__header" id="skill__heading">
            <h1>
              <span
                data-aos="fade-down"
                data-aos-delay="0"
                data-aos-offset="200"
              >
                S
              </span>
              <span
                data-aos="fade-down"
                data-aos-delay="200"
                data-aos-offset="200"
              >
                K
              </span>
              <span
                data-aos="fade-down"
                data-aos-delay="400"
                data-aos-offset="200"
              >
                I
              </span>
              <span
                data-aos="fade-down"
                data-aos-delay="600"
                data-aos-offset="200"
              >
                L
              </span>
              <span
                data-aos="fade-down"
                data-aos-delay="800"
                data-aos-offset="200"
              >
                L
              </span>
              <span
                data-aos="fade-down"
                data-aos-delay="1000"
                data-aos-offset="200"
              >
                .
              </span>
            </h1>
          </div>
          <div className="skill__inner-container">
            <div className="skill__info">
              <div className="skill__details-container">
                <div className="skill__details">
                  <h4>Programming Language</h4>
                  <ul>
                    <li>
                      <span>Python</span>
                    </li>
                    <li>
                      <span>
                        R Programming
                      </span>
                    </li>
                    <li>
                      <span>
                        SQL
                      </span>
                    </li>
                    <li>
                      <span>
                        HTML
                      </span>
                    </li>
                    <li>
                      <span>
                        CSS
                      </span>
                    </li>
                  </ul>
                </div>
                <div className="skill__details">
                  <h4>IDEs</h4>
                  <ul>
                    <li>
                      <span>
                       Jupyter Notebook  
                      </span>
                    </li>
                    <li>
                      <span>PyCharm</span>
                    </li>
                    <li>
                      <span>Google Colab</span>
                    </li>
                    <li>
                      <span>VS Code</span>
                    </li>
                   
                  </ul>
                </div>
                <div className="skill__details">
                  <h4>Python Library and Frameworks</h4>
                  <ul>
                    <li>
                      <span>
                       Tkinter
                      </span>
                    </li>
                    <li>
                      <span>Streamlit</span>
                    </li>
                    <li>
                      <span>Django</span>
                    </li>
                    <li>
                      <span>Flask</span>
                    </li>
                   
                  </ul>
                </div>
                <div className="skill__details">
                  <h4>Libraries</h4>
                  <ul>
                    <li>
                      <span>Numpy</span>
                    </li>
                    <li>
                      <span>Pandas</span>
                    </li>
                    <li>
                      <span>Matplotlib</span>
                    </li>
                    <li>
                      <span>Seaborn</span>
                    </li>
                    <li>
                      <span>Scikit-learn</span>
                    </li>
                    <li>
                      <span>NLTK</span>
                    </li>
                    <li>
                      <span>Request</span>
                    </li>
                    <li>
                      <span>BeautiFulSoup</span>
                    </li>
                    <li>
                      <span>Selenium</span>
                    </li>
                    <li>
                      <span>Tensorflow</span>
                    </li>
                    <li>
                      <span>Keras</span>
                    </li>
                    <li>
                      <span>PyTorch</span>
                    </li>
                    <li>
                      <span>OpenCv</span>
                    </li>
                  </ul>
                </div>
                <div className="skill__details">
                  <h4>Generative AI Technologies</h4>
                  <ul>
                    <li>
                      <span>Google Gemini</span>
                    </li>
                    <li>
                      <span>OpenAI</span>
                    </li>
                    <li>
                      <span>Llama2</span>
                    </li>
                  
                  </ul>
                </div>
                <div className="skill__details">
                  <h4>Tools</h4>
                  <ul>
                    <li>
                      <span>Power BI</span>
                    </li>
                    <li>
                      <span>MS Excel</span>
                    </li>
                    <li>
                      <span>Tableau</span>
                    </li>
                  
                  </ul>
                </div>
                <div className="skill__details">
                  <h4>Deployment Platforms</h4>
                  <ul>
                    <li>
                      <span>GIT</span>
                    </li>
                    <li>
                      <span>AWS</span>
                    </li>
                  </ul>
                </div>
                
              </div>
            </div>

            {/* 3D Text Cloud  */}
            <div className="skill__cloud">
              <div className="tagcloud" data-aos="zoom-in-up" data-aos-offset="200"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Skill;
